let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kJloj")).then(() => parcelRequire('2wnh1'));